<template>
  <div
    id="info-block"
    :style="{
      borderColor: getTheme.fore,
      backgroundColor: getTheme.glass,
      boxShadow: '0 5px 5px 5px ' + getTheme.glass
    }"
  >
    <div v-if="blockName === 'about'">
      <h1>About Georatio</h1>
      <p>
        If you find a bug or would like to request a feature, please email me at
        tres@treshenry.net (<a
          :style="{ color: getTheme.fore }"
          href="mailto:tres@treshenry.net"
          >mailto</a
        >).
      </p>
      <p>
        Special thanks to Sam Block for his input on Georatio. Sam is at
        <a :style="{ color: getTheme.fore }" href="https://digitalambler.com"
          >digitalambler.com</a
        >.
      </p>
      <p>
        Special thanks to Yale Lespar for his work on
        <a
          :style="{ color: getTheme.fore }"
          href="https://minorfracture.blog/2024/01/23/foundations-of-nonastrological-geomancy/"
          >Novenary charts</a
        >
        . Yale is at
        <a :style="{ color: getTheme.fore }" href="https://minorfracture.blog"
          >Minor Fracture</a
        >.
      </p>
      <p>
        You can find me at
        <a :style="{ color: getTheme.fore }" href="https://hallofdoors.com"
          >hallofdoors.com</a
        >.
      </p>
      <p>Georatio is Copyright © 2025 Tres Henry</p>
    </div>
    <a
      class="button"
      @click="closeInfo"
      @mouseenter="toggleClose()"
      @mouseleave="toggleClose()"
      :style="buttonStyles"
      >Close</a
    >
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "InfoBlock",
  data() {
    return {
      exitHover: false
    };
  },
  computed: {
    ...mapGetters(["getTheme"]),
    buttonStyles() {
      if (this.exitHover) {
        return {
          borderColor: this.getTheme.fore,
          backgroundColor: this.getTheme.fore,
          color: this.getTheme.back
        };
      } else {
        return {
          borderColor: this.getTheme.fore,
          backgroundColor: this.getTheme.back,
          color: this.getTheme.fore
        };
      }
    },
    blockName() {
      return this.$store.state.blockName;
    },
    chartCode() {
      return `${window.location.protocol}//${window.location.host}${this.$store.getters.getChartUrl}`;
    }
  },
  methods: {
    toggleClose() {
      this.exitHover = !this.$data.exitHover;
    },
    closeInfo() {
      this.$store.commit("setBlockName", "");
    }
  }
};
</script>

<style lang="scss" scoped>
#info-block {
  border-width: 1px;
  border-style: solid;
  padding: 10px;
  position: absolute;
  width: 828px;
  z-index: 1;
  backdrop-filter: blur(6px);
}

.button {
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  padding: 5px;
  border-left-width: 1px;
  border-left-style: solid;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  cursor: pointer;
}

h1 {
  padding: 0;
  margin: 0;
  font-size: 1.3rem;
}

p {
  font-size: 1.1rem;
  line-height: 1.5rem;

  a {
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
